import React from 'react';
import {
  Luggage,
  NoCabinLuggage,
  NoInfoCabinLuggage,
  NoInfoLuggage,
  NoInfoSkiLuggage,
  NoLuggage,
  NoSkiLuggage,
  NoWeightCabinLuggage,
  NoWeightLuggage,
  NoWeightSkiLuggage,
  SkiLuggage,
  CabinLuggage,
} from '@lt/components/icons-react/luggage/index';
import type { LuggageType } from 'src/components/Luggage/types';

type BaggageIconProps = {
  noBaggage: boolean;
  type: LuggageType;
  weightUnknown: boolean;
  baggageUnknown: boolean;
};

const ICONS = {
  hand: <CabinLuggage />,
  handNoLuggage: <NoCabinLuggage />,
  handUnknown: <NoInfoCabinLuggage />,
  handNoWeight: <NoWeightCabinLuggage />,
  hold: <Luggage />,
  holdNoLuggage: <NoLuggage />,
  holdUnknown: <NoInfoLuggage />,
  holdNoWeight: <NoWeightLuggage />,
  ski: <SkiLuggage />,
  skiNoLuggage: <NoSkiLuggage />,
  skiUnknown: <NoInfoSkiLuggage />,
  skiNoWeight: <NoWeightSkiLuggage />,
};

export const getIcon = ({
  type,
  weightUnknown,
  noBaggage,
  baggageUnknown,
}: BaggageIconProps): JSX.Element => {
  const editedType = type.split('_')[0];
  switch (true) {
    case weightUnknown:
      return ICONS[`${editedType}NoWeight`];
    case noBaggage:
      return ICONS[`${editedType}NoLuggage`];
    case baggageUnknown:
      return ICONS[`${editedType}Unknown`];
    default:
      return ICONS[editedType];
  }
};
